import { FC, useEffect, useState } from "react";
import { t } from "@lingui/macro";
import { Button, Form, FormInstance, Input, InputNumber, Space } from "antd";
import { CommissionConfig, SubscriptionPackage } from "../type";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";

export const DEFAULT_COMMISSION_VALUE: CommissionConfig = {
	fee: 0,
	percent: 0,
	start: 0,
	end: 0,
};
interface CommissionsProps {
	form: FormInstance<SubscriptionPackage>;
}
const Commissions: FC<CommissionsProps> = ({ form }) => {
	const [commissions, setCommissions] = useState<CommissionConfig[]>([]);

	const data: CommissionConfig[] = form.getFieldValue("commissions");
	const handelCommissionAdded = () => {
		setCommissions(prev => {
			const newCommissions = [...form.getFieldValue("commissions")];
			newCommissions.push(DEFAULT_COMMISSION_VALUE);
			form.setFieldValue("commissions", newCommissions);
			return newCommissions;
		});
	};

	const handleCommissionRemoved = (index: number) => {
		setCommissions(prev => {
			const newCommissions = [...form.getFieldValue("commissions")];
			newCommissions.splice(index, 1);
			form.setFieldValue("commissions", newCommissions);
			return newCommissions;
		});
	};
	useEffect(() => {
		!commissions?.length && setCommissions(data);
	}, [data?.length]);

	return (
		<div className="shadow-lg px-5 pt-5 pb-10 bg-white p-5 w-full">
			<div className="mt-3 flex justify-between mb-4">
				<label className="font-semibold text-lg">{t`Commission`}</label>
			</div>
			<div className="w-full space-y-5">
				{commissions?.map((_, index) => (
					<Space key={index} className="w-full">
						{index
							? t`For each used car sale with price`
							: t`For each used car sale will take`}
						{index ? (
							<>
								<Form.Item label="" name={["commissions", index, "start"]}>
									<InputNumber className="w-32" min={0} placeholder={t`Min`} />
								</Form.Item>
								<Form.Item label="" name={["commissions", index, "end"]}>
									<InputNumber className="w-32" min={0} placeholder={t`Max`} />
								</Form.Item>
								{t`will take`}
							</>
						) : null}

						<Form.Item label="" name={["commissions", index, "fee"]}>
							<InputNumber addonAfter={t`USD`} className="w-32" min={0} />
						</Form.Item>
						{t`and`}
						<Form.Item label="" name={["commissions", index, "percent"]}>
							<InputNumber addonAfter="%" className="w-32 ml-2" min={0} />
						</Form.Item>
						{index ? (
							<DeleteOutlined
								className="text-[#828282] ml-2 text-lg cursor-pointer"
								onClick={() => handleCommissionRemoved(index)}
							/>
						) : null}
					</Space>
				))}
				<Button
					icon={<PlusOutlined />}
					type="primary"
					className="flex items-center ml-2 !text-gray-500 !border-gray-300 hover:bg-white focus:bg-white"
					htmlType="button"
					onClick={handelCommissionAdded}
				>
					{t`Add`}
				</Button>
			</div>
		</div>
	);
};

export default Commissions;
